import { render, staticRenderFns } from "./SampleTypeList.vue?vue&type=template&id=58f1a1f4&"
import script from "./SampleTypeList.ts?vue&type=script&lang=js&"
export * from "./SampleTypeList.ts?vue&type=script&lang=js&"
import style0 from "./SampleTypeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports